import UtilI18N, { type Locales } from "@dia-ui/util_i18n";
import { getElement, forceUpdate } from "@stencil/core";

export interface I18N {
    //@ts-ignore
    I18N: UtilI18N
}

export type {
    Locales
};

/**
 * I18N
 * @constructor
 * example: data-i18n-locale="de"
 */
export const I18N = () => {
    let baseLocale: string = "de",
        localeAttribute: string = "data-i18n-locale",
        htmlLangAttribute: string = "lang",
        useFallbackCache: boolean = true;

    return (proto: any, _property: string) => {
        const { componentWillLoad, componentDidLoad } = proto;

        proto.componentDidLoad = function() {
            let element= getElement(this);

            proto.I18N.observeElementLocale(element, () => {
              forceUpdate(this);
            });

            proto.I18N.observeOwnerDocumentLocale(element.ownerDocument, () => {
              forceUpdate(this);
            }, element);

            return componentDidLoad && componentDidLoad.call(this);
        };

        proto.componentWillLoad = async function () {
            let element= getElement(this),
                //@ts-ignore
                locale: Locales = baseLocale,
                ownerDocument = element.ownerDocument.getElementsByTagName("html")[0],
                i18nPath= proto.getComponentAssetPath.call(this,'/i18n/');

            if (ownerDocument.hasAttribute(htmlLangAttribute)) {
                //@ts-ignore
                locale = ownerDocument.getAttribute(htmlLangAttribute);
            }

            if (element.hasAttribute(localeAttribute)) {
                //@ts-ignore
                locale = element.getAttribute(localeAttribute);
            }

            proto.I18N = new UtilI18N();
            await proto.I18N.initialize(locale, i18nPath, useFallbackCache);

            return componentWillLoad && componentWillLoad.call(this);
        };

        return proto;
    };
}
